import { Select, styled } from '@mui/material';

export default styled(Select)({
  '& .MuiInputBase-input': {
    fontSize: '1.25rem',
    minHeight: '1.25rem',
  },
});
